module.exports = __webpack_public_path__ + "img/3-disabled.504cab5c.png";